<template>
  <div class="reward-descript">
    <div class="teacher-descript">
      <div class="info-left ban">
        <div class="title">{{course_info.course_name}}</div>
        <div class="course-item">
          <span>课程讲师：
            <i v-for="(item,index) in course_info.teachers" class="mr10" :key="index">
              {{item.teacher_name}}
            </i>
          </span>
          <span>直播时间:{{course_info.updated_at}}</span>
        </div>
      </div>
      <div class="info-center ban">
        <p class="head-title">打赏金额（元）</p>
        <p class="num">{{course_info.reward}}</p>
        <p class="send blue cp" @click="payTeacher(course_info)">支付给讲师</p>
      </div>
      <div class="info-right ban">
        <p class="head-title">打赏人数</p>
        <p class="num">{{course_info.reward_user_total}}</p>
      </div>
    </div>

    <div class="list-wrap" v-if="resultData.list&&resultData.list.length>=0">
      <el-table
        ref="table"
        stripe
        :data="resultData.list"
        :header-cell-style="{backgroundColor:'#f5f7fa'}"
        style="width: 100%;margin: 20px 0;"
      >
        <el-table-column label="用户名称" prop="user_nick_name"></el-table-column>
        <el-table-column label="打赏时间" prop="updated_at"></el-table-column>
        <el-table-column prop="total_amount" label="打赏金额"></el-table-column>
        <el-table-column label="操作" fixed="right">
          <template slot-scope="scope">
            <!-- {{scope.row.pay_state}} -->
            <el-button type="text" v-if="scope.row.pay_state==1" size="mini">待支付</el-button>
            <el-button type="text" v-if="scope.row.pay_state==2" size="mini" @click="refundSign(scope.row)" >退回</el-button>
            <el-button type="text" v-if="scope.row.pay_state==3" size="mini">已退款</el-button>            
            <el-button type="text" v-if="scope.row.pay_state==4" size="mini">支付失败</el-button> 
          </template>
        </el-table-column>
      </el-table>
      <div class="tc">
        <el-pagination
          background
          @current-change="handleCurrentChange"
          :current-page="Number(search.page)"
          :page-size="Number(search.size)"
          layout="total, prev, pager, next"
          :total="Number(resultData.count)"
        ></el-pagination>
      </div>
    </div>

    <!-- 标注弹框 -->
    <el-dialog title="退款标注" :visible.sync="signDialogVisible" width="30%">
      <div class="product-info">
        <div class="left">
          <p class="title">商品名称</p>
          <p class="item">{{order_info.goods_name}}</p>
        </div>
        <div class="right">
          <p class="title">退款金额（元）</p>
          <p class="item" style="padding-right:20px;">￥{{order_info.total_amount}}</p>
        </div>
      </div>
      <div slot="footer" class="tc">
        <el-button @click="signDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submit()">确 定</el-button>
      </div>
    </el-dialog>
    <!-- //支付给讲师的弹窗 -->
    <PayMoney
      :respondVisible.sync="respondVisible"
      :resmessage="resmessage"
      @uploadInfo="uploadInfo"
    ></PayMoney>
  </div>
</template>


<script>
import Title from "@/components/title";
//导入mixins
import order_mixins from "./components/order-mixins";
//导入组件
import PayMoney from "./components/pay-money";

import {_rewardSingleInfo,_orderRrfund } from "@/api/order";

import { _courseSingTopic } from "@/api/course";

export default {
  data() {
    return {
      //订单信息
      order_info: {},
      signDialogVisible: false,
      resultData: {},
      search:{
        page:1,
        size:10
      },
      //课程信息
      course_info:{}
    };
  },
  mixins: [order_mixins],
  created() {
    this.rewardSingleInfo();
    this.courseSingTopic();
  },
  computed:{

  },
  props: {
    order_id: {
      type: String,
      default: ""
    }
  },
  components: {
    Title,
    PayMoney
  },
  methods: {
    //加载单个的打赏的课程信息
    courseSingTopic() {
      _courseSingTopic({
        params: {
          course_id: this.$route.params.id,
          goods_mode: 1
        }
      }).then(res => {
        if (res.resultCode == 1) {
          this.course_info = res.result;
        } else {
          this.$message.error(res.errorMsg);
        }
      });
    },
    //单个课程的打赏信息
    rewardSingleInfo() {
      _rewardSingleInfo({
        params: {
          page:this.search.page,
          size:this.search.size,
          course_id: this.$route.params.id
          // course_id: 1
        }
      }).then(res => {
        console.log(res);
        if (res.resultCode == 1) {
          this.resultData=res.result
        } else {
          this.$message.error(res.errorMsg);
        }
      });
    },
    //翻页
    handleCurrentChange(val){
      this.search.page=val;
      this.rewardSingleInfo();
    },
    // 退款标注
    refundSign(item) {
      this.order_info = item;
      this.signDialogVisible = true;
    },
    orderSingleRrfund(){
       _orderRrfund({
        params: {
          id: this.order_info.order_id
        }
      }).then(res => {
        if (res.resultCode == 1) {
          this.$message.success(res.errorMsg);
          this.rewardSingleInfo();
        } else {
          this.$message.error(res.errorMsg);
        }
      });
    },
    //提交金额
    submit() {
      this.orderSingleRrfund();
      this.signDialogVisible = false;
    },
    //回复消息返回的状态
    uploadInfo(val) {
      if (val) {
        console.log(val);
      }
    }
  }
};
</script>

<style lang="less" scoped>
.reward-descript {
  .teacher-descript {
    height: 140px;
    width: 100%;
    display: flex;
    .ban {
      background: #fefefe;
      border-radius: 22px;
      padding: 20px;
    }
    .info-left {
      flex: 6;
      margin-right: 80px;
      .title {
        width: 60%;
        height: 60px;
        font-size: 20px;
        line-height: 30px;
        font-weight: 500;
        overflow: hidden;
      }
      .course-item {
        margin-top: 20px;
        span:first-child {
          margin-right: 100px;
        }
      }
    }
    .info-center {
      flex: 2;
      margin-right: 20px;
      padding-left: 50px;
      .head-title {
        font-size: 16px;
        margin-bottom: 18px;
      }
      .num {
        font-size: 26px;
        font-weight: 600;
        margin-bottom: 18px;
      }
    }
    .info-right {
      flex: 2;
      padding-left: 50px;
      .head-title {
        font-size: 16px;
        margin-bottom: 18px;
      }
      .num {
        font-size: 26px;
        font-weight: 600;
      }
    }
  }
  .list-wrap {
    margin-top: 40px;
    .order-list {
      text-align: right;
      font-size: 16px;
      padding-right: 20px;
      line-height: 30px;
    }
  }
  .product-info {
    display: flex;
    .left {
      flex: 1;
      text-align: left;
    }
    .right {
      flex: 1;
      text-align: right;
    }
    .title {
      font-size: 16px;
      margin-bottom: 20px;
    }
  }
}
</style>
